import { gql } from "@apollo/client"

export const TOURNAMENT_EDIT = gql`
  mutation TournamentEdit($TournamentEditInput: TournamentEditInput!) {
    TournamentEdit(input: $TournamentEditInput) {
      status {
        success
        name
        detail
      }
      tournament {
        id
        name
      }
    }
  }
`
